import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridsterModule } from 'angular-gridster2';
import { DashboardItemComponent } from './dashboard-item.component';
import { DashboardComponent } from './dashboard.component';

@NgModule({
  imports: [CommonModule, GridsterModule],
  exports: [DashboardComponent, DashboardItemComponent],
  declarations: [DashboardComponent, DashboardItemComponent]
})
export class DashboardModule {}
